import {AfterViewInit, Component} from '@angular/core';
import {FieldType, FieldTypeConfig, FormlyModule} from '@ngx-formly/core';
import {AlertController, IonInput, IonItem, IonText} from '@ionic/angular/standalone';

import {TranslateModule} from '@ngx-translate/core';
import {FocusNextOnEnterDirective} from '../../directives/focus-next-on-enter.directive';
import {ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'string-formly-type',
  template: `
    <ion-item lines="full">
      <div style="width: 100%; padding-top: 8px;">
        <ion-text (click)="ionInput.setFocus()" [color]="showError && formControl.errors ? 'danger': ''">
          {{ props.label }}
          <ion-text color="medium">
            @if (!props.required) {
              <small>(Optional)</small>
            }
          </ion-text>
          @if (props.description) {
            <button style="background: none; margin-left: 8px;" (click)="showInfo()">ⓘ</button>
          }
          <!--          @if (showError) {-->
          <!--            <formly-validation-message style="color: var(&#45;&#45;ion-color-danger)" [field]="field"></formly-validation-message>-->
          <!--          }-->
        </ion-text>

        <ion-input [type]="props.type === 'number' || props.type === 'integer' ? 'number' : props.type" aria-label=" "
                   #ionInput [formControl]="formControl"
                   [formlyAttributes]="field" appFocusNextOnEnter
                   style="color: var(--ion-color-medium)" [placeholder]="'(Empty)' | translate"
                   [id]="String(field.key)" [attr.data-testid]="field.key" [attr.data-label]="props.label"></ion-input>
        @if (props.maxLength) {
          <ion-text color="medium" style="font-size: 12px;">
            {{ 'Characters' | translate:{count: formControl?.value?.length || 0, max: props.maxLength} }}
          </ion-text>
        }
      </div>
    </ion-item>
  `,
  imports: [TranslateModule, FormlyModule, FocusNextOnEnterDirective, ReactiveFormsModule, IonInput, IonText, IonItem]
})
export class InputFormlyType extends FieldType<FieldTypeConfig> implements AfterViewInit {

  public constructor(private readonly alertController: AlertController) {
    super();
  }

  public ngAfterViewInit(): void {
  }

  public showInfo() {
    this.alertController.create({
      header: 'Info',
      message: this.props.description,
      buttons: ['OK']
    }).then(alert => alert.present());
  }

  protected readonly String = String;
}
